<ion-header [translucent]="true">
    <ion-toolbar>
        <ion-title>About</ion-title>

        <ion-buttons slot="secondary">
            <app-pwa-prompt></app-pwa-prompt>
        </ion-buttons>
    </ion-toolbar>
</ion-header>

<ion-content [fullscreen]="true">
    <ion-header collapse="condense">
        <ion-toolbar>
            <ion-title size="large">About</ion-title>
        </ion-toolbar>
    </ion-header>

    <div class="loader" *ngIf="loading">
        <ion-spinner></ion-spinner>
    </div>

    <div class="markdown-container">
        <markdown [src]="url" [disableSanitizer]="true" (load)="loading = false"></markdown>
    </div>

    <div class="version">
        <span class="text-selectable">CloudpilotEmu version {{ version }}</span>
        <br />
        @if (appType !== undefined) {
            <span class="text-selectable">{{ appType }}</span>
            <br />
        }
        <a href="javascript:" (click)="showChangelog()">Changelog</a>
        @if (serviceWorkerAvailable) {
            <div>app cached for offline use</div>
            <a href="javascript:" (click)="resetWorker()">reset worker</a>
        }
    </div>

    <img class="logo" src="assets/logo.svg" />
</ion-content>
